import { useEffect, useState } from "react";
import { User } from "../interfaces/user";

export const useSession = () => {
  const [currentUser, setCurrentUser] = useState<User | null>(
    JSON.parse(localStorage.getItem("DSOTF_LOGIN_HINT_KEY") || "{}")
  );

  useEffect(() => {
    const handleCustomEvent = (event: any) => {
      setCurrentUser(event.detail);
    };

    window.addEventListener("DSOTF_LOGIN_HINT_KEY_updated", handleCustomEvent);

    return () => {
      window.removeEventListener(
        "DSOTF_LOGIN_HINT_KEY_updated",
        handleCustomEvent
      );
    };
  }, []);

  const userLoggedIn = () => {
    return (
      currentUser?.firstName !== undefined && currentUser?.firstName !== null
    );
  };

  const isLoggedIn = () => {
    return userLoggedIn() ? "yes" : "no";
  };

  return { currentUser, isLoggedIn, userLoggedIn };
};

export default useSession;
